import { createFileRoute, Link } from '@tanstack/react-router';

/**
 * Landing pública do botão "Confirmar" do template WhatsApp de confirmação
 * de sessão (L-05). Spec: "Confirmar não muda nada no Nosso Ello" — então
 * é só uma página estática de agradecimento, sem chamadas, sem auth.
 */
export const Route = createFileRoute('/sessao/confirmada')({
  component: SessionConfirmedPage,
});

function SessionConfirmedPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <div className="max-w-sm w-full text-center bg-white rounded-2xl shadow-sm border border-slate-200 p-8 space-y-4">
        <div className="mx-auto w-14 h-14 rounded-full bg-teal-50 flex items-center justify-center">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="text-teal-500">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </div>
        <h1 className="text-xl font-bold text-slate-800">Presença confirmada</h1>
        <p className="text-sm text-slate-500 leading-relaxed">
          Obrigado por confirmar! Até logo na sua sessão. 💙
        </p>
        <Link to="/" className="inline-block text-sm font-medium text-teal-600 hover:underline">
          Ir para o Nosso Ello
        </Link>
      </div>
    </div>
  );
}
